import {
    Badge,
    Box,
    Flex,
    Grid,
    GridItem,
    Icon,
    Image,
    List,
    Spinner,
    Stack,
    Text,
} from "@chakra-ui/react";
import { WarningIcon } from "@phosphor-icons/react/dist/ssr";
import { React, useEffect, useState } from "react";

import ButtonCompartir from "@/components/fichas/buttonCompartir";
import ButtonRecorridoVirtual from "@/components/fichas/buttonVirtual";
import CardCitaResponsive from "@/components/fichas/cardCitaResponsive";
import PhotoGallery from "@/components/fichas/PhotoGallery";
import Map from "@/components/general/Map";
import MarkerFicha from "@/components/general/MarkerFicha";
import { useGetPropertyByIdQuery } from "@/hooks/microservicesApi";
import { default as retailjson } from "@/utilities/retail/retail.json";

import Section from "../general/Section";

const ListItemCharacteristic = ({ children, icon, value }) => {
    return (
        <Stack direction="row" align="center" placeSelf="center" mb={2}>
            <Image boxSize="30px" objectFit="cover" src={icon} alt={children} loading="lazy" />
            <Text
                fontWeight="700"
                fontSize="xs"
                mb={2}
                color="black"
                textAlign="start"
                paddingLeft="10px"
            >
                {children}{" "}
                <Text fontWeight="400" fontSize="xs" mb={2} color="black" textAlign="start">
                    {value}
                </Text>{" "}
            </Text>
        </Stack>
    );
};

const FichaPropiedadMobile = ({ id, city, savePropsFavorites, session, userFavorites }) => {
    const [urlShare, setUrlShare] = useState(null);
    const [property, setProperty] = useState(null);
    const [marker, setMarker] = useState({});
    const [images, setImages] = useState([]);
    const [amenities, setAmenities] = useState([]);
    const [price, setPrice] = useState(0);
    const [currency, setCurrency] = useState("MXN");
    const [location, setLocation] = useState("");
    const [broker, setBroker] = useState({});
    const [operation, setOperation] = useState("Venta");
    const [antiquity, setAntiquity] = useState("Usado");
    const [serviceRoom, setServiceRoom] = useState("N/D");
    const [displayContact, setDisplayContact] = useState(true);
    const [offset, setOffset] = useState(0);
    const [isFavorite, setIsFavorite] = useState(false);

    const { data } = useGetPropertyByIdQuery(id);

    //Validar si el desarrollo es favorito
    useEffect(() => {
        if (data) {
            setIsFavorite(userFavorites?.some((fav) => fav.property_id === data[0]?.property_id));
        }
    }, [data, userFavorites]);

    useEffect(() => {
        if (data) {
            if (data.length > 0) {
                if (city === "guiarent") {
                    if (data[0].labels.includes("GUIARENT")) {
                        setProperty(data[0]);
                    } else {
                        setProperty("NO DATA");
                    }
                } else {
                    setProperty(data[0]);
                }
                let data_ = data[0];
                let marker_ = {
                    position: {
                        lat: data_.location_props ? data_.location_props.latitude : data_.latitude,
                        lng: data_.location_props
                            ? data_.location_props.longitude
                            : data_.longitude,
                    },
                    title: data_.title,
                };
                setMarker(marker_);
                setImages(data_.photo_props);
                setAmenities(data_.amenities);

                if (data_["sale"]) {
                    setPrice(Intl.NumberFormat().format(data_["sale"]));
                    setCurrency(data_["sale_currency"] ? data_["sale_currency"] : "MXN");
                    setOperation("Venta");
                }
                if (data_["lease"]) {
                    setPrice(Intl.NumberFormat().format(data_["lease"]));
                    setCurrency(data_["lease_currency"] ? data_["lease_currency"] : "MXN");
                    setOperation("Renta");
                }
                if (data_["presale"]) {
                    setPrice(Intl.NumberFormat().format(data_["presale"]));
                    setCurrency(data_["presale_currency"] ? data_["presale_currency"] : "MXN");
                    setOperation("Preventa");
                }

                if (data_.conservation_props.age_year < 0) {
                    setAntiquity("En construcción");
                } else if (
                    data_.conservation_props.age_year === 0 ||
                    data_.conservation_props.age_year === null ||
                    data_.conservation_props.state === "EXCELLENT"
                ) {
                    setAntiquity("Nuevo");
                } else {
                    setAntiquity("Usado");
                }

                let location_ =
                    data_.location_props.street_name +
                    " " +
                    (data_.location_props.external_number || data_.location_props.exterior_number) +
                    " " +
                    data_.location_props.neighborhood +
                    " " +
                    (data_.location_props.postal_code ? data_.location_props.postal_code : "") +
                    " " +
                    data_.location_props.city +
                    " " +
                    data_.location_props.province;

                setLocation(location_.toLocaleLowerCase());

                let broker_ = {
                    name: data_.full_name,
                    image: "https://media.wiggot.mx/" + data_.broker_photo + "-m.jpg",
                    phone: data_.communication_props.phone,
                    email: data_.email,
                };
                setBroker(broker_);

                if (data_.structure_props.service_room !== null) {
                    if (data_.has_service_room == true) setServiceRoom("Si");
                    else setServiceRoom("N/D");
                }
            } else {
                const property_ = retailjson.find((item) => item.code === id);
                if (property_) {
                    setProperty(property_);
                    let data_ = property_;
                    let marker_ = {
                        position: {
                            lat: data_?.location_props
                                ? data_?.location_props.latitude
                                : data_.latitude,
                            lng: data_.location_props
                                ? data_.location_props.longitude
                                : data_.longitude,
                        },
                        title: data_.title,
                    };
                    setMarker(marker_);
                    setImages(data_.photo_props);
                    setAmenities(data_.amenities);

                    if (data_["sale"]) {
                        setPrice(Intl.NumberFormat().format(data_["sale"]));
                        setCurrency(data_["currency"] ? data_["currency"] : "MXN");
                        setOperation("Venta");
                    }
                    if (data_["lease"]) {
                        setPrice(Intl.NumberFormat().format(data_["lease"]));
                        setCurrency(data_["currency"] ? data_["currency"] : "MXN");
                        setOperation("Renta");
                    }
                    if (data_["presale"]) {
                        setPrice(Intl.NumberFormat().format(data_["presale"]));
                        setCurrency(data_["currency"] ? data_["currency"] : "MXN");
                        setOperation("Preventa");
                    }

                    if (data_.conservation_props.age_year < 0) {
                        setAntiquity("En construcción");
                    } else if (
                        data_.conservation_props.age_year === 0 ||
                        data_.conservation_props.age_year === null ||
                        data_.conservation_props.state === "EXCELLENT"
                    ) {
                        setAntiquity("Nuevo");
                    } else {
                        setAntiquity("Usado");
                    }

                    let location_ =
                        data_.location_props.street_name +
                        " " +
                        data_.location_props.external_number +
                        " " +
                        data_.location_props.neighborhood +
                        " " +
                        (data_.location_props.postal_code ? data_.location_props.postal_code : "") +
                        " " +
                        data_.location_props.city +
                        " " +
                        data_.location_props.province;

                    setLocation(location_.toLocaleLowerCase());

                    let broker_ = {
                        name: data_.full_name,
                        image: "https://media.wiggot.mx/" + data_.broker_photo + "-m.jpg",
                        phone: data_.communication_props.phone,
                        email: data_.email,
                    };
                    setBroker(broker_);

                    if (data_.structure_props.service_room !== null) {
                        if (data_.has_service_room == true) setServiceRoom("Si");
                        else setServiceRoom("N/D");
                    }
                } else {
                    setProperty("NO DATA");
                }
            }
        }
    }, [data]);

    useEffect(() => {
        if (property) {
            setUrlShare(
                city
                    ? "https://grupoguia.mx/" +
                          city +
                          "/Propiedad/wig-" +
                          id +
                          "?operation=" +
                          (property?.sale_active
                              ? "sale"
                              : property?.presale_active
                                ? "presale"
                                : "lease")
                    : "https://grupoguia.mx/Propiedad/wig-" +
                          id +
                          "?operation=" +
                          (property.sale_active
                              ? "sale"
                              : property?.presale_active
                                ? "presale"
                                : "lease")
            );
        }
    }, [property]);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
    }, [typeof window === "undefined" ? 0 : window.pageYOffset]);

    const handleScroll = () => {
        setOffset(window.pageYOffset);
        if (offset === 0 || window.pageYOffset < 150 || window.pageYOffset < offset) {
            setDisplayContact(true);
        } else {
            setDisplayContact(false);
        }
    };

    return (
        <>
            {property && urlShare ? (
                <>
                    {property === "NO DATA" ? (
                        <Stack my={20} alignItems="center">
                            <Icon boxSize="50px" color="brand.500">
                                <WarningIcon weight="fill" />
                            </Icon>
                            <Text fontWeight="700" fontSize="2xl">
                                Lo sentimos, esta propiedad no está disponible.
                            </Text>
                        </Stack>
                    ) : (
                        <>
                            <Section
                                id="cita"
                                position="fixed"
                                h="24"
                                right="0"
                                bottom="0"
                                textAlign="center"
                                shadow="md"
                                target="_blank"
                                rel="noopener noreferrer"
                                alignItems="center"
                                justifyContent="center"
                                external
                                bg="white"
                                color="white"
                                fontSize="2xl"
                                _hover={{ shadow: "xl", textDecoration: "none" }}
                                transitionDuration=".6s"
                                zIndex="998"
                                borderTopWidth="1px"
                                borderTopColor="gray.200"
                                display={displayContact ? "block" : "none"}
                                animation="fadeInUp"
                                animationDuration="1s"
                            >
                                <CardCitaResponsive
                                    urlBrochure="none"
                                    numeroAsesor={broker.phone}
                                    nameAsesor={broker.name}
                                    tipo="Propiedad"
                                    city={city}
                                    id={id}
                                    hubspotForm={
                                        city === "retail"
                                            ? property.external_props.hubspot.hbs_contact
                                            : "03479824-13fb-4023-a9c1-a35a76088498"
                                    }
                                    urlDev={urlShare}
                                />
                            </Section>

                            <Box
                                bg="whiteAlpha.100"
                                color="gray.600"
                                w="full"
                                mx="auto"
                                maxW="7xl"
                                px={{ base: "0", md: "8" }}
                                mt={20}
                            >
                                <Grid templateColumns="repeat(5, 1fr)" gap={2} mt="50px" mx={6}>
                                    {city != "retail" && (
                                        <GridItem colSpan={2}>
                                            <Text
                                                fontWeight="400"
                                                fontSize="xs"
                                                mb={2}
                                                color="black"
                                                textAlign="start"
                                            >
                                                Código: {id}
                                            </Text>
                                        </GridItem>
                                    )}
                                    <GridItem colSpan={3}>
                                        <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                                            <GridItem colSpan={1} placeSelf="end">
                                                <ButtonCompartir
                                                    icon="https://media.grupoguia.mx/assets/home-page/fichas/compartir.webp"
                                                    url={urlShare}
                                                    fontsize="xs"
                                                >
                                                    {" "}
                                                    Compartir{" "}
                                                </ButtonCompartir>
                                            </GridItem>
                                            {session && (
                                                <GridItem colSpan={1} placeSelf="end">
                                                    <Flex
                                                        gap={3}
                                                        align="center"
                                                        cursor="pointer"
                                                        _hover={{ bg: "gray.100" }}
                                                        _active={{ bg: "gray.200" }}
                                                        p={2}
                                                        borderRadius="md"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            savePropsFavorites(
                                                                data[0]?.property_id,
                                                                null
                                                            ); /// property_id, development_id
                                                        }}
                                                    >
                                                        <Image
                                                            src={
                                                                isFavorite
                                                                    ? "https://media.grupoguia.mx/assets/apps-icons/favorite_active.svg"
                                                                    : "https://media.grupoguia.mx/assets/apps-icons/favorite.svg"
                                                            }
                                                            alt="favorite"
                                                            maxH="3vh"
                                                        />

                                                        <Text
                                                            fontWeight="400"
                                                            fontSize="sm"
                                                            color="black"
                                                            textAlign="end"
                                                        >
                                                            Favorito
                                                        </Text>
                                                    </Flex>
                                                </GridItem>
                                            )}
                                        </Grid>
                                    </GridItem>
                                </Grid>

                                <Section marginBottom="2" pl={0} className="FichaPropiedad">
                                    <PhotoGallery
                                        imageUrls={
                                            property?.youtube_url
                                                ? [property.youtube_url, ...images]
                                                : images
                                        }
                                        pl={0}
                                        mt={4}
                                        px={0}
                                    />
                                </Section>

                                {property.matterport_url ? (
                                    <Box textAlign="center" w="100%" position="relative" top="-7">
                                        <ButtonRecorridoVirtual url={property.matterport_url} />
                                    </Box>
                                ) : null}

                                <Grid templateColumns="repeat(1, 1fr)" gap={2} mx={6}>
                                    <GridItem colSpan={1}>
                                        <Text
                                            fontWeight="700"
                                            fontSize="lg"
                                            color="black"
                                            textTransform="capitalize"
                                        >
                                            {property.title}
                                        </Text>
                                    </GridItem>
                                    <GridItem colSpan={1}>
                                        {price ? (
                                            <Text
                                                fontWeight="400"
                                                fontSize="md"
                                                mb={1}
                                                color="black"
                                            >
                                                {city !== "retail"
                                                    ? "Total de " + operation.toLowerCase()
                                                    : "Desde "}
                                                : ${price} {currency}{" "}
                                            </Text>
                                        ) : null}
                                    </GridItem>
                                    <GridItem colSpan={1}>
                                        <Grid templateColumns="repeat(2, 1fr)" gap={1}>
                                            <GridItem colSpan={1} placeSelf="start">
                                                <Badge
                                                    paddingLeft="5"
                                                    paddingRight="5"
                                                    paddingTop="1"
                                                    paddingBottom="1"
                                                    borderRadius="full"
                                                    mx={1}
                                                    my={1}
                                                    color="white"
                                                    bg="#414141"
                                                    fontWeight="400"
                                                    fontSize="xs"
                                                >
                                                    {operation}
                                                </Badge>
                                            </GridItem>
                                            {property.antiquity_years ? (
                                                <GridItem colSpan={1} placeSelf="start">
                                                    <Badge
                                                        paddingLeft="5"
                                                        paddingRight="5"
                                                        paddingTop="1"
                                                        paddingBottom="1"
                                                        borderRadius="full"
                                                        mx={1}
                                                        my={1}
                                                        color="white"
                                                        bg="#414141"
                                                        fontWeight="400"
                                                        fontSize="xs"
                                                        maxWidth="100%"
                                                    >
                                                        {property.antiquity_years} años de
                                                        antigüedad
                                                    </Badge>
                                                </GridItem>
                                            ) : null}
                                            <GridItem colSpan={1} placeSelf="start">
                                                <Badge
                                                    paddingLeft="5"
                                                    paddingRight="5"
                                                    paddingTop="1"
                                                    paddingBottom="1"
                                                    borderRadius="full"
                                                    mx={1}
                                                    my={1}
                                                    color="white"
                                                    bg="#414141"
                                                    fontWeight="400"
                                                    fontSize="xs"
                                                >
                                                    {antiquity}
                                                </Badge>
                                            </GridItem>
                                        </Grid>
                                    </GridItem>
                                </Grid>

                                {/*<GridItem colSpan={2}>
              <CardAsesorPropiedad
              email={broker.email}
              telefono={broker.phone}
              imagen={broker.image}
              nombre={broker.name}
              />
              </GridItem>*/}

                                <Grid templateColumns="repeat(2, 1fr)" gap={9} mx={6}>
                                    <GridItem colSpan={2}>
                                        <GridItem
                                            rowSpan={1}
                                            colSpan={2}
                                            marginTop="8"
                                            paddingBottom="8"
                                            borderBottomWidth={1}
                                            borderStyle="solid"
                                            borderColor="gray.200"
                                        >
                                            <Grid templateColumns="repeat(4, 1fr)" gap={2}>
                                                <GridItem
                                                    colSpan={1}
                                                    display="flex"
                                                    textAlign="center"
                                                    justifySelf="center"
                                                    alignItems="center"
                                                >
                                                    <Image
                                                        src="https://media.grupoguia.mx/assets/home-page/fichas/icons/bed.svg"
                                                        alt="simple icon"
                                                        w={8}
                                                        mr={4}
                                                    />

                                                    <Text fontSize="sm" fontWeight="400">
                                                        {property.structure_props.bedrooms}
                                                    </Text>
                                                </GridItem>
                                                <GridItem
                                                    colSpan={1}
                                                    display="flex"
                                                    textAlign="center"
                                                    justifySelf="center"
                                                    alignItems="center"
                                                >
                                                    <Image
                                                        src="https://media.grupoguia.mx/assets/home-page/fichas/icons/headband.svg"
                                                        alt="simple icon"
                                                        w={8}
                                                        mr={4}
                                                    />

                                                    <Text fontSize="xs" fontWeight="400">
                                                        {property.structure_props.ground_size}{" "}
                                                        mt&sup2;
                                                    </Text>
                                                </GridItem>
                                                <GridItem
                                                    colSpan={1}
                                                    display="flex"
                                                    textAlign="center"
                                                    justifySelf="center"
                                                    alignItems="center"
                                                >
                                                    <Image
                                                        src="https://media.grupoguia.mx/assets/home-page/fichas/icons/bath.svg"
                                                        alt="simple icon"
                                                        w={8}
                                                        mr={4}
                                                    />

                                                    <Text fontSize="sm" fontWeight="400">
                                                        {property.structure_props.bathrooms}
                                                    </Text>
                                                </GridItem>
                                                <GridItem
                                                    colSpan={1}
                                                    display="flex"
                                                    textAlign="center"
                                                    justifySelf="center"
                                                    alignItems="center"
                                                >
                                                    <Image
                                                        src="https://media.grupoguia.mx/assets/home-page/fichas/icons/parking-lot.svg"
                                                        alt="simple icon"
                                                        w={8}
                                                        mr={4}
                                                    />

                                                    <Text fontSize="sm" fontWeight="400">
                                                        {property.structure_props.parking_lots}
                                                    </Text>
                                                </GridItem>
                                            </Grid>
                                        </GridItem>
                                        <GridItem
                                            rowSpan={1}
                                            colSpan={2}
                                            marginTop="8"
                                            paddingBottom="8"
                                            borderBottomWidth={1}
                                            borderStyle="solid"
                                            borderColor="gray.200"
                                        >
                                            <Text
                                                fontWeight="700"
                                                fontSize="lg"
                                                mb={6}
                                                color="black"
                                            >
                                                {" "}
                                                Descripción:{" "}
                                            </Text>
                                            <Text
                                                fontWeight="400"
                                                fontSize="md"
                                                mb={0}
                                                color="black"
                                                textAlign="justify"
                                                marginTop="20px"
                                            >
                                                {property.description}
                                            </Text>
                                        </GridItem>
                                        <GridItem
                                            rowSpan={1}
                                            colSpan={2}
                                            marginTop="8"
                                            paddingBottom="8"
                                            borderBottomWidth={1}
                                            borderStyle="solid"
                                            borderColor="gray.200"
                                        >
                                            <Text
                                                fontWeight="700"
                                                fontSize="lg"
                                                mb={6}
                                                color="black"
                                            >
                                                {" "}
                                                Características:{" "}
                                            </Text>
                                            <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                                                {property.structure_props.ground_size ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/cinta-metrica.webp"
                                                            value={
                                                                property.structure_props
                                                                    .ground_size + " m²"
                                                            }
                                                        >
                                                            Metros del terreno:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}
                                                {property.structure_props.construction_size ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/pared-de-ladrillo.webp"
                                                            value={
                                                                property.structure_props
                                                                    .construction_size + " m²"
                                                            }
                                                        >
                                                            Metros de construcción:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}
                                                {property.structure_props.floors ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/escalera.webp"
                                                            value={property.structure_props.floors}
                                                        >
                                                            Niveles:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}

                                                {property.structure_props.bedrooms ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/bed.webp"
                                                            value={
                                                                property.structure_props.bedrooms
                                                            }
                                                        >
                                                            Número de cuartos:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}
                                                {property.structure_props.bathrooms ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/banera.webp"
                                                            value={
                                                                property.structure_props.bathrooms
                                                            }
                                                        >
                                                            Número de baños:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}
                                                {property.structure_props.half_bathrooms ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/bano.webp"
                                                            value={
                                                                property.structure_props
                                                                    .half_bathrooms
                                                            }
                                                        >
                                                            Número de medios baños:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}
                                                {property.structure_props.parking_lots ? (
                                                    <GridItem colSpan={1} placeSelf="start">
                                                        <ListItemCharacteristic
                                                            icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/estacionamiento.webp"
                                                            value={
                                                                property.structure_props
                                                                    .parking_lots
                                                            }
                                                        >
                                                            Estacionamientos:
                                                        </ListItemCharacteristic>
                                                    </GridItem>
                                                ) : null}
                                                <GridItem colSpan={1} placeSelf="start">
                                                    <ListItemCharacteristic
                                                        icon="https://media.grupoguia.mx/assets/home-page/fichas/Caracteristicas/lavadora.webp"
                                                        value={serviceRoom}
                                                    >
                                                        Cuarto de servicio:
                                                    </ListItemCharacteristic>
                                                </GridItem>
                                            </Grid>
                                        </GridItem>
                                        {amenities?.length > 0 ? (
                                            <GridItem
                                                rowSpan={1}
                                                colSpan={2}
                                                marginTop="8"
                                                paddingBottom="8"
                                                borderBottomWidth={1}
                                                borderStyle="solid"
                                                borderColor="gray.200"
                                            >
                                                <Text
                                                    fontWeight="700"
                                                    fontSize="lg"
                                                    mb={6}
                                                    color="black"
                                                >
                                                    {" "}
                                                    Amenidades:{" "}
                                                </Text>
                                                <Grid templateColumns="repeat(1, 1fr)" gap={2}>
                                                    {amenities.map((amenity) => (
                                                        <>
                                                            <GridItem colSpan={1} placeSelf="start">
                                                                <List.Root ml={4}>
                                                                    <List.Item fontSize="sm">
                                                                        {amenity.replaceAll(
                                                                            "-",
                                                                            " "
                                                                        )}
                                                                    </List.Item>
                                                                </List.Root>
                                                            </GridItem>
                                                        </>
                                                    ))}
                                                </Grid>
                                            </GridItem>
                                        ) : null}
                                        <GridItem rowSpan={1} marginTop="8">
                                            <Stack
                                                direction="row"
                                                align="center"
                                                placeSelf="center"
                                                mb={2}
                                            >
                                                <Image
                                                    boxSize="30px"
                                                    objectFit="cover"
                                                    src="https://media.grupoguia.mx/assets/home-page/fichas/Ubicacion/ubicacion.webp"
                                                    alt="ubicación"
                                                    loading="lazy"
                                                />

                                                <Text
                                                    fontWeight="700"
                                                    fontSize="lg"
                                                    mb={2}
                                                    color="black"
                                                    textAlign="start"
                                                    paddingLeft="10px"
                                                >
                                                    Ubicación:
                                                    <Text
                                                        fontWeight="400"
                                                        fontSize="sm"
                                                        mb={2}
                                                        color="black"
                                                        textAlign="start"
                                                        textTransform="capitalize"
                                                    >
                                                        {location}
                                                    </Text>
                                                </Text>
                                            </Stack>
                                            <Stack
                                                direction="row"
                                                align="center"
                                                h="400px"
                                                placeSelf="center"
                                                mb={2}
                                            >
                                                <Map>
                                                    <MarkerFicha marker={marker} />
                                                </Map>
                                            </Stack>
                                        </GridItem>
                                    </GridItem>
                                </Grid>
                            </Box>
                        </>
                    )}
                </>
            ) : (
                <Stack my={20} alignItems="center">
                    <Spinner />
                    <Text>Cargando ...</Text>
                </Stack>
            )}
        </>
    );
};

export default FichaPropiedadMobile;
